import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MultiStepOnboarding from "./MultiStepOnboarding";
import AdminDashboard from "./AdminDashboard";

function App() {
  return (
    <BrowserRouter basename="/wfmf">
      <Routes>

        {/* Default onboarding page */}
        <Route path="/" element={<MultiStepOnboarding />} />

        {/* Admin can open onboarding directly */}
        <Route path="/onboarding" element={<MultiStepOnboarding />} />

        {/* Admin Dashboard */}
        <Route path="/admin" element={<AdminDashboard />} />

        {/* Fix for index.html or unknown routes */}
        <Route path="*" element={<MultiStepOnboarding />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;